export class Pillar2ComplianceLegends {
  id: string;
  groups: Pillar2ComplianceLegendsGroup[] = [];
}

export class Pillar2ComplianceLegendsGroup {
  title: string;
  settingsCommandName?: string;
  settingsBoardId?: string;
  items: Pillar2ComplianceLegendsItem[] = [];
}

export class Pillar2ComplianceLegendsItem {
  icon: string;
  iconClass: string;
  label: string;
}
